import { render } from "./AlertIf18.vue?vue&type=template&id=e537aae2&scoped=true"
import script from "./AlertIf18.vue?vue&type=script&lang=js"
export * from "./AlertIf18.vue?vue&type=script&lang=js"

import "./AlertIf18.vue?vue&type=style&index=0&id=e537aae2&lang=scss&scoped=true"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/theearcasino/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e537aae2"]])

export default __exports__